/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { LegalSubjectsComponent } from 'src/app/legal-subjects/legal-subjects.component';
import { LocalStorageService } from 'src/app/local-storage.service';
import { SubjectsComponent } from 'src/app/subjects/subjects.component';
import { CpsuSubjectService } from 'src/services/cpsu-subject.service';
import { OciService } from 'src/services/oci.service';
import { UserService } from 'src/services/user.service';
import * as myLetters from '../../letters';
/**
 * @author Olja Andjelovski olja.andjelovski@iten.rs
 */
interface shipingInterface {
   id: Number;
   title: string;
   outgoingMailKindCode: string;
   methodCode: string;
}

const SHIPPING_CHANNEL_POST_PERSONAL = 4;
const SHIPPING_CHANNEL_POST_ID = 3;
const SHIPPING_CHANNEL_POST_EMAIL_ID = 2;
const SHIPPING_CHANNEL_EPOST = 1;

const SUBJECT_TYPE_INDIVIDUAL_ID = 1;
const SUBJECT_TYPE_LEGAL_ID = 2;

@Component({
   selector: 'sending-documents',
   templateUrl: './sending-documents.component.html',
   styleUrls: ['./sending-documents.component.scss'],
})
export class SendingDocumentsComponent implements OnInit {
   visible: boolean;

   sendingDocumentsForm: FormGroup;
   choosedShippingMethod = '';
   choosedShippingChannel = '';
   subjectId = null;
   dataSource = new MatTableDataSource<any>([]);
   receivers: any = [];
   displayedColumns: string[] = ['subjectType', 'shippingChannel', 'name', 'email', 'pib', 'address', 'actions'];
   /* Kanal slanja */
   shippingChannel: shipingInterface[] = [
      { id: SHIPPING_CHANNEL_POST_ID, title: 'Пошта - Пошта Србије', outgoingMailKindCode: '001', methodCode: '001' },
      { id: SHIPPING_CHANNEL_POST_PERSONAL, title: 'Пошта - Пошта Србије лично', outgoingMailKindCode: '002', methodCode: '007' },
      { id: SHIPPING_CHANNEL_POST_EMAIL_ID, title: 'Пошта - Е-маил', outgoingMailKindCode: '012', methodCode: '006' },
      { id: SHIPPING_CHANNEL_EPOST, title: 'У еСандуче', outgoingMailKindCode: '012', methodCode: 'еС' },
   ];

   /* Tip primaoca */
   subjectType: shipingInterface[] = [
      { id: SUBJECT_TYPE_INDIVIDUAL_ID, title: 'Физичко лице', outgoingMailKindCode: '', methodCode: '' },
      { id: SUBJECT_TYPE_LEGAL_ID, title: 'Правно лице', outgoingMailKindCode: '', methodCode: '' },
   ];
   isSubjectChosen: boolean;
   chosenSubject: any;
   sendDissabled = false;
   isSending = false;
   loggedIn: any;
   isCpsuUser = false;
   constructor(
      private dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public router: Router,
      public dialogRef: MatDialogRef<SendingDocumentsComponent>,
      private fb: FormBuilder,
      private localStorageService: LocalStorageService,
      private ociService: OciService,
      private userService: UserService,
      private cpsuSubjectService: CpsuSubjectService,
   ) {
      this.isCpsuUser = this.userService.isCpsuUser();
      this.visible = false;
      this.sendingDocumentsForm = this.fb.group({
         sendingMethod: ['', [Validators.required]],
         recipientType: ['', [Validators.required]],
         receiverDetails: this.fb.array([]),
      });
      this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
      this.localStorageService.set('localStorageCenterId', this.loggedIn?.csrId);
   }
   receiverDetails(): FormArray {
      return this.sendingDocumentsForm.get('receiverDetails') as FormArray;
   }

   ngOnInit() {}

   onChangeSendingMethod(event: any) {
      this.receiverDetails().clear();

      if (event.value.id === SHIPPING_CHANNEL_POST_ID || event.value.id === SHIPPING_CHANNEL_POST_PERSONAL || event.value.id === SHIPPING_CHANNEL_EPOST) {
         this.choosedShippingChannel = 'POST';

         if (this.isSubjectChosen) {
            this.sendingDocumentsForm.removeControl('email');
            this.choosedShippingMethod === 'INDIVIDUAL' ? this.addSubjectAddressControls() : this.addLegalSubjectAddressControls();
         }
      } else {
         this.choosedShippingChannel = 'E_MAIL';

         if (this.isSubjectChosen) {
            this.removeAddressControls();
            this.addEmailControls();
         }
      }
   }

   onChangeReceiverType(event: any) {
      if (this.isSubjectChosen) {
         this.removeControls();
      }
      if (event.value.id === SUBJECT_TYPE_INDIVIDUAL_ID) {
         this.choosedShippingMethod = 'INDIVIDUAL';
      } else {
         this.choosedShippingMethod = 'LEGAL';
      }
   }

   sendDocument() {
      this.isSending = true;
      const receiverDto = this.receivers;
      for (const receiver of receiverDto) {
         receiver.outgoingMailKindCode = receiver.shippingChannel.outgoingMailKindCode;
         receiver.shippingMethodCode = receiver.shippingChannel.methodCode;
         receiver.shippingChannel = receiver.shippingChannel.id;
         receiver.subjectType = receiver.subjectType.id;
      }

      const body = {
         caseId: this.data.document.caseId,
         caseName: this.data.document.caseName,
         documentId: this.data.document.documentId,
         receivers: receiverDto,
      };

      this.ociService.documentSendExpedition(body).subscribe(
         res => {
            if (res != null) {
               this.sendDissabled = false;
               this.isSending = false;
               this.dialogRef.close({ event: 'Create', data: res });
            } else {
               this.sendDissabled = false;
               this.isSending = false;
               this.dialogRef.close({ event: 'Unsuccessful', data: res });
            }
         },
         error => {
            this.sendDissabled = false;
            this.isSending = false;
            this.dialogRef.close({ event: 'Unsuccessful' });
         },
      );
   }

   closeDialog() {
      this.dialogRef.close({ event: 'Cancel' });
   }
   importSubjectData() {
      this.isSubjectChosen = false;
      const dialogRef = this.dialog.open(SubjectsComponent, {
         panelClass: 'overlay-panel',
         width: '1200px',
         data: {
            origin: 'entrance',
         },
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result !== undefined) {
            this.isSubjectChosen = true;
            this.chosenSubject = result.data;
            if (this.isCpsuUser) {
               this.subjectId = result.data.id;
            } else {
               this.subjectId = result.data.subjectIdentity.subjectId;
            }

            this.sendingDocumentsForm.addControl('firstName', new FormControl('', Validators.compose([Validators.pattern(myLetters.letters)])));
            this.sendingDocumentsForm.addControl('lastName', new FormControl('', Validators.compose([Validators.pattern(myLetters.letters)])));
            this.sendingDocumentsForm.addControl('subjectId', new FormControl('', null));
            this.sendingDocumentsForm.addControl('csrId', new FormControl('', null));

            this.sendingDocumentsForm.patchValue({
               firstName: result.data.firstName,
               lastName: result.data.lastName,
               subjectId: this.isCpsuUser ? result.data.fromSubjectId : this.subjectId,
               csrId: this.isCpsuUser ? result.data.fromCsrId : result.data.subjectIdentity.csrId,
            });

            this.choosedShippingChannel === 'E_MAIL' ? this.addEmailControls() : this.addSubjectAddressControls();

            this.sendingDocumentsForm.markAllAsTouched();
         }
      });
   }

   importLegalSubject() {
      this.isSubjectChosen = false;
      const dialogRef = this.dialog.open(LegalSubjectsComponent, {
         panelClass: 'overlay-panel',
         width: '1200px',
         data: {
            origin: 'entrance',
         },
      });

      dialogRef.afterClosed().subscribe(result => {
         if (result !== undefined) {
            this.isSubjectChosen = true;
            this.chosenSubject = result.data;

            this.subjectId = result.data.id;

            this.sendingDocumentsForm.addControl('name', new FormControl(''));
            this.sendingDocumentsForm.addControl('pib', new FormControl(''));

            this.sendingDocumentsForm.patchValue({
               name: result.data.name,
               pib: result.data.pib,
            });

            this.choosedShippingChannel === 'E_MAIL' ? this.addEmailControls() : this.addLegalSubjectAddressControls();

            this.sendingDocumentsForm.markAllAsTouched();
         }
      });
   }

   addReciverToList() {
      this.isSubjectChosen = false;
      const receiver = {
         shippingChannel: this.sendingDocumentsForm.get('sendingMethod').value,
         subjectType: this.sendingDocumentsForm.get('recipientType').value,
         lastName: this.sendingDocumentsForm.get('lastName') === null ? '' : this.sendingDocumentsForm.get('lastName').value,
         firstName: this.sendingDocumentsForm.get('firstName') === null ? '' : this.sendingDocumentsForm.get('firstName').value,
         name: this.sendingDocumentsForm.get('name') === null ? '' : this.sendingDocumentsForm.get('name').value,
         pib: this.sendingDocumentsForm.get('pib') === null ? '' : this.sendingDocumentsForm.get('pib').value,
         subjectId: this.choosedShippingMethod === 'INDIVIDUAL' && this.sendingDocumentsForm.controls.subjectId.value !== null ? this.sendingDocumentsForm.controls.subjectId.value : this.subjectId,
         csrId: this.choosedShippingMethod === 'INDIVIDUAL' && this.sendingDocumentsForm.controls.csrId.value !== null ? this.sendingDocumentsForm.controls.csrId.value : '',
         email: this.sendingDocumentsForm.get('email') === null ? '' : this.sendingDocumentsForm.get('email').value,
         ptt: this.sendingDocumentsForm.get('ptt') === null ? '' : this.sendingDocumentsForm.get('ptt').value,
         street: this.sendingDocumentsForm.get('street') === null ? '' : this.sendingDocumentsForm.get('street').value,
         number: this.sendingDocumentsForm.get('number') === null ? '' : this.sendingDocumentsForm.get('number').value,
         subnumber: this.sendingDocumentsForm.get('subnumber') === null ? '' : this.sendingDocumentsForm.get('subnumber').value,
         city: this.sendingDocumentsForm.get('city') === null ? '' : this.sendingDocumentsForm.get('city').value,
         settlement: this.sendingDocumentsForm.get('settlement') === null ? '' : this.sendingDocumentsForm.get('settlement').value,
      };
      this.receivers.push(receiver);
      this.dataSource.data = this.receivers;
      this.choosedShippingChannel = '';
      this.choosedShippingMethod = '';
      this.sendingDocumentsForm = this.fb.group({
         sendingMethod: ['', [Validators.required]],
         recipientType: ['', [Validators.required]],
         receiverDetails: this.fb.array([]),
      });
      this.sendingDocumentsForm.controls.sendingMethod.markAsUntouched();
      this.sendingDocumentsForm.controls.recipientType.markAsUntouched();
      this.sendingDocumentsForm.controls.sendingMethod.setErrors(null);
      this.sendingDocumentsForm.controls.recipientType.setErrors(null);
   }

   removeReceiver(index: number) {
      this.receivers.splice(index, 1);
      this.dataSource.data = this.receivers;
   }

   setPrimaryReceiver(index: number) {
      const element = this.receivers[index];
      this.receivers.splice(index, 1);
      this.receivers.splice(0, 0, element);
      this.dataSource.data = this.receivers;
   }

   removeControls() {
      this.sendingDocumentsForm.removeControl('email');

      this.removeAddressControls();

      this.sendingDocumentsForm.removeControl('name');
      this.sendingDocumentsForm.removeControl('pib');

      this.sendingDocumentsForm.removeControl('firstName');
      this.sendingDocumentsForm.removeControl('lastName');

      this.isSubjectChosen = false;
   }

   addLegalSubjectAddressControls() {
      this.addAddressControls();

      this.sendingDocumentsForm.patchValue({
         ptt: this.chosenSubject.address.ptt,
         street: this.chosenSubject.address?.street,
         number: this.chosenSubject.address?.number,
         subnumber: this.chosenSubject.address?.subnumber,
         city: this.chosenSubject.address?.town,
         settlement: this.chosenSubject.address?.populatedPlace?.title,
      });
   }

   async addSubjectAddressControls() {
      this.addAddressControls();
      if (this.isCpsuUser && this.chosenSubject.permanentResidence == null) {
         const data = await this.cpsuSubjectService.getExpeditionData(this.subjectId).toPromise();
         this.chosenSubject.permanentResidence = data.permanentResidence;
         this.chosenSubject.email = data.email;
      }

      this.sendingDocumentsForm.patchValue({
         ptt: this.chosenSubject.permanentResidence?.ptt,
         street: this.chosenSubject.permanentResidence?.street,
         number: this.chosenSubject.permanentResidence?.number,
         subnumber: this.chosenSubject.permanentResidence?.subnumber,
         city: this.chosenSubject.permanentResidence?.town,
         settlement: this.chosenSubject.permanentResidence?.populatedPlace?.title,
      });
   }

   addAddressControls() {
      this.sendingDocumentsForm.addControl('ptt', new FormControl('', Validators.compose([Validators.pattern(myLetters.pttValidator)])));
      this.sendingDocumentsForm.addControl('street', new FormControl(''));
      this.sendingDocumentsForm.addControl('number', new FormControl(''));
      this.sendingDocumentsForm.addControl('subnumber', new FormControl(''));
      this.sendingDocumentsForm.addControl('city', new FormControl(''));
      this.sendingDocumentsForm.addControl('settlement', new FormControl(''));
   }

   removeAddressControls() {
      this.sendingDocumentsForm.removeControl('ptt');
      this.sendingDocumentsForm.removeControl('street');
      this.sendingDocumentsForm.removeControl('number');
      this.sendingDocumentsForm.removeControl('subnumber');
      this.sendingDocumentsForm.removeControl('city');
      this.sendingDocumentsForm.removeControl('settlement');
   }

   async addEmailControls() {
      this.sendingDocumentsForm.addControl('email', new FormControl('', Validators.compose([Validators.required, Validators.email])));
      if (this.isCpsuUser && this.choosedShippingMethod === 'INDIVIDUAL' && this.chosenSubject.permanentResidence == null) {
         const data = await this.cpsuSubjectService.getExpeditionData(this.subjectId).toPromise();
         this.chosenSubject.permanentResidence = data.permanentResidence;
         this.chosenSubject.email = data.email;
      }
      this.sendingDocumentsForm.patchValue({
         email: this.chosenSubject.email,
      });
   }
}
